import React from 'react';
import { Table } from 'react-bootstrap';
import { toMonetaryFormat } from '../../../common/Utilities';

export default function BudgetTable({
  projectBudgetDetails,
  budgetDetailsTotals
}) {
  const generateTotalsRow = () => {
    return (
      <tr>
        <td>Totals</td>
        <td className="align-right totals-budget">{toMonetaryFormat(budgetDetailsTotals.totalMandays)}</td>
        <td className="align-right totals-budget" >{toMonetaryFormat(budgetDetailsTotals.totalRevenue)}</td>
        <td className="align-right totals-budget">{toMonetaryFormat(budgetDetailsTotals.totalFullyLoadedCost)}</td>
        <td className="align-right totals-budget">{toMonetaryFormat(budgetDetailsTotals.totalUnloadedCost)}</td>
        <td className="align-right totals-budget">{toMonetaryFormat(budgetDetailsTotals.totalExternalCost)}</td>
        <td className="align-right totals-budget">{toMonetaryFormat(budgetDetailsTotals.totalTotalCost)}</td>
        <td className="align-right totals-budget">{toMonetaryFormat(budgetDetailsTotals.totalProfitBeforeTax)}</td>
        <td className="align-right totals-budget">{toMonetaryFormat(budgetDetailsTotals.totalProfitNetofTax)}</td>
      </tr>
    )
  }

  return (
    <Table>
      <thead>
        <tr>
          <th className="align-center remove-th-style"></th>
          <th className="align-center">Total Mandays</th>
          <th className="align-center">Total Revenue</th>
          <th className="align-center">Fully Loaded Cost</th>
          <th className="align-center">Unloaded Cost</th>
          <th className="align-center">Other Cost</th>
          <th className="align-center">Total Cost</th>
          <th className="align-center">Profit Before Tax</th>
          <th className="align-center">Profit after Tax</th>
        </tr>
      </thead>
      <tbody>
        { projectBudgetDetails }
        { generateTotalsRow() }
      </tbody>
    </Table>
  )
}

